import {ErrorMessage, useField} from 'formik';
import _ from 'lodash';
import React from 'react';
import Select from 'react-select';
import {FormErrorMessage} from '../../../../form-features/FormErrorMessage';
import {SelectStructure} from '../SelectStructure';

export const FormikSelect = ({name, options, disabled, label, prefix, onFocus, onChange, ...props}) => {
    let [, fieldMeta, fieldHelpers] = useField(name);

    const currentValue = fieldMeta.value;

    async function handleChange(ev) {
        await fieldHelpers.setValue(ev.value);
        if (_.isFunction(onChange)) {
            onChange(ev.value);
        }
    }

    //react select uses "label" instead of "key" (used in the old component)
    //we translate this here not to have to change it in all occurrences in the application
    const translatedOptions = _.map(options, (o) => ({
        ...o,
        label: o.label ?? o.key,
    }));

    const defaultValue = _.find(translatedOptions, {value: currentValue});

    return (
        <SelectStructure
            label={label}
            prefix={prefix}
            disabled={disabled}
            errorMessage={<ErrorMessage name={name} component={FormErrorMessage} />}>
            <Select
                {...props}
                classNamePrefix="dropdown-select"
                options={translatedOptions}
                value={defaultValue}
                onChange={handleChange}
                onFocus={onFocus}
                isDisabled={disabled}
            />
        </SelectStructure>
    );
};
